import { SettingsCategoriesSection } from "@/components/settings";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/$workspaceSlug/settings/categories")({
  component: SettingsCategoriesSection,
});
